// extracted by mini-css-extract-plugin
export default {"pageTitle":"create-ticket-type_pageTitle__1YYtc"};